import ViewPortInlay from 'components/general/ViewPortInlay';
import WGroup from 'components/general/WGroup';
import { wGroupIndicesATComingSoon } from '../menu/comingSoon';

const ComingSoonEditBoard = () => (
  <WGroup index={wGroupIndicesATComingSoon.COMING_SOON}>
    <ViewPortInlay text="New edit boards coming soon..." />
  </WGroup>
);

export default ComingSoonEditBoard;
